var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66663 19.8333V22.1666C4.66663 22.7855 4.91246 23.379 5.35004 23.8165C5.78763 24.2541 6.38112 24.5 6.99996 24.5H21C21.6188 24.5 22.2123 24.2541 22.6499 23.8165C23.0875 23.379 23.3333 22.7855 23.3333 22.1666V19.8333M8.16663 12.8333L14 18.6666M14 18.6666L19.8333 12.8333M14 18.6666V4.66663",
    stroke: "#00A9A9",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.5c066ed94b1eab0cb320edd3bf9358c3.svg";
export { ForwardRef as ReactComponent };